import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, AlertTriangle, Heart } from "lucide-react";
import api from "../lib/api";

export default function UnsubscribePage() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [state, setState] = useState("loading"); // loading | done | invalid
    const [email, setEmail] = useState("");

    useEffect(() => {
        if (!token) { setState("invalid"); return; }
        api.get(`/marketing/unsubscribe?token=${encodeURIComponent(token)}`)
            .then(({ data }) => {
                setEmail(data.email || "");
                setState("done");
            })
            .catch(() => setState("invalid"));
    }, [token]);

    return (
        <div data-testid="unsubscribe-page" className="min-h-[70vh] grid place-items-center px-6 py-20" style={{ background: "var(--bg)" }}>
            <div className="max-w-xl text-center card-soft bg-white p-10">
                {state === "loading" && (
                    <>
                        <p className="label-tiny" style={{ color: "var(--rose-deep)" }}>★ Even geduld</p>
                        <h1 className="font-display text-4xl mt-3">Uitschrijven...</h1>
                    </>
                )}

                {state === "done" && (
                    <>
                        <div className="w-20 h-20 rounded-full mx-auto flex items-center justify-center" style={{ background: "var(--rose-tint)" }}>
                            <CheckCircle2 size={40} style={{ color: "var(--rose-deep)" }} />
                        </div>
                        <p className="label-tiny mt-6" style={{ color: "var(--rose-deep)" }}>★ Uitgeschreven</p>
                        <h1 className="font-display text-4xl mt-3" data-testid="unsubscribe-success">
                            Je bent uitgeschreven.
                        </h1>
                        <p className="mt-5 text-base" style={{ color: "var(--text-2)" }}>
                            {email && (<>Het adres <span className="font-mono-dm">{email}</span> ontvangt geen marketing-mails meer van ons.</>)}
                        </p>
                        <p className="mt-3 text-sm" style={{ color: "var(--text-3)" }}>
                            Bestelbevestigingen en service-mails blijven we wel sturen — dat zijn geen marketing.
                        </p>
                        <div className="mt-8 flex flex-wrap justify-center gap-3">
                            <Link to="/" className="btn-ghost" data-testid="unsub-back-home">← Naar de winkel</Link>
                            <Link to="/contact" className="btn-rose" data-testid="unsub-contact">
                                <Heart size={14} /> Iets te zeggen?
                            </Link>
                        </div>
                    </>
                )}

                {state === "invalid" && (
                    <>
                        <div className="w-20 h-20 rounded-full mx-auto flex items-center justify-center" style={{ background: "var(--bg-warm)" }}>
                            <AlertTriangle size={40} style={{ color: "var(--text-2)" }} />
                        </div>
                        <p className="label-tiny mt-6" style={{ color: "var(--text-2)" }}>★ Link ongeldig</p>
                        <h1 className="font-display text-4xl mt-3">Deze link werkt niet meer.</h1>
                        <p className="mt-5 text-base" style={{ color: "var(--text-2)" }}>
                            De uitschrijflink is mogelijk al gebruikt of verkeerd gekopieerd.
                            Stuur ons een mail en we verwijderen je adres handmatig.
                        </p>
                        <div className="mt-8 flex justify-center gap-3">
                            <Link to="/contact" className="btn-rose" data-testid="unsub-invalid-contact">Stuur ons een mail</Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
